import { useState, type KeyboardEvent } from 'react';

const navLinks = [
  { label: '今日速报', href: '#feed' },
  { label: '黑料档案', href: '#archive' },
  { label: '黑料名单', href: '#list' },
  { label: '正在热议', href: '#discussion' },
  { label: '专题合集', href: '#collections' },
];

const SUBMIT_EMAIL = 'tips@melonwatch.demo';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [notice, setNotice] = useState('');
  const [submitOpen, setSubmitOpen] = useState(false);
  const [copyText, setCopyText] = useState('复制投稿邮箱');

  const runSearch = () => {
    if (!keyword.trim()) {
      setNotice('演示站点：先输入一个关键词再检索');
      return;
    }
    setNotice(`演示站点：已记录关键词「${keyword.trim()}」，本期未接入检索服务`);
  };

  const handleSearchKey = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      runSearch();
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(SUBMIT_EMAIL);
      setCopyText('已复制到剪贴板');
    } catch {
      setCopyText('请手动复制上方邮箱');
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="hidden md:flex items-center justify-between h-9 px-4 md:px-8 text-xs text-foreground-600 border-b border-background-200/70">
        <div className="flex items-center gap-2 min-w-0">
          <span className="inline-flex items-center gap-1 font-medium text-primary-700">
            <i className="ri-fire-line" />
            24 小时热榜持续更新
          </span>
          <span className="text-foreground-300">·</span>
          <span className="truncate">本站内容为网友整理，仅供吃瓜参考，请理性看待</span>
        </div>
        <div className="flex items-center gap-5 shrink-0">
          <a href="#archive" className="hover:text-foreground-950 transition-colors">最新档案</a>
          <a href="#discussion" className="hover:text-foreground-950 transition-colors">热评现场</a>
        </div>
      </div>

      <div className="flex items-center gap-3 px-4 md:px-8 h-14 md:h-16">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-fire-fill text-lg" />
          </span>
          <h1 className="font-heading text-xl md:text-2xl font-black text-foreground-950 whitespace-nowrap">
            网红黑料
          </h1>
        </a>

        <nav className="hidden lg:flex items-center gap-1 ml-4">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex-1" />

        <div className="hidden md:flex items-center gap-2 h-10 pl-3 pr-1 rounded-full border border-background-300 bg-background-50 w-64 lg:w-72">
          <i className="ri-search-line text-foreground-500" />
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            onKeyDown={handleSearchKey}
            type="text"
            placeholder="搜网红 / 搜事件关键词"
            className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
          />
          <button
            type="button"
            onClick={runSearch}
            className="h-8 px-3 rounded-full bg-foreground-950 text-background-50 text-xs font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
          >
            检索
          </button>
        </div>

        <button
          type="button"
          onClick={() => setSubmitOpen(true)}
          className="hidden sm:inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          <i className="ri-add-line" />
          我要投稿
        </button>

        <button
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="打开导航菜单"
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {notice ? (
        <div className="px-4 md:px-8 pb-2 text-xs text-primary-700">{notice}</div>
      ) : null}

      {menuOpen ? (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <div className="flex items-center gap-2 h-10 pl-3 pr-1 rounded-full border border-background-300 mb-3">
            <i className="ri-search-line text-foreground-500" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              onKeyDown={handleSearchKey}
              type="text"
              placeholder="搜网红 / 搜事件关键词"
              className="flex-1 bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
            <button
              type="button"
              onClick={runSearch}
              className="h-8 px-3 rounded-full bg-foreground-950 text-background-50 text-xs whitespace-nowrap cursor-pointer"
            >
              检索
            </button>
          </div>
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md bg-background-100 text-sm text-foreground-800 text-center"
              >
                {item.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              setSubmitOpen(true);
            }}
            className="mt-3 w-full h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            我要投稿
          </button>
        </div>
      ) : null}

      {submitOpen ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-foreground-950/40">
          <div className="w-full max-w-md rounded-lg bg-background-50 border border-background-200 p-6">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950">投稿与线索</h3>
                <p className="mt-1 text-xs text-foreground-600">演示站点，暂未接入真实投稿通道。</p>
              </div>
              <button
                type="button"
                onClick={() => setSubmitOpen(false)}
                aria-label="关闭"
                className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 cursor-pointer hover:bg-background-100"
              >
                <i className="ri-close-line text-xl" />
              </button>
            </div>

            <ul className="mt-5 space-y-3 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-600" />
                提供可核对的原始截图或链接，注明时间点。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-600" />
                尽量区分「已核实」与「待核实」，避免只给结论。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-600" />
                涉及个人隐私的信息一律不收。
              </li>
            </ul>

            <div className="mt-5 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2.5">
              <i className="ri-mail-line text-foreground-600" />
              <span className="flex-1 text-sm text-foreground-900 break-all">{SUBMIT_EMAIL}</span>
              <button
                type="button"
                onClick={handleCopy}
                className="shrink-0 h-8 px-3 rounded-md bg-foreground-950 text-background-50 text-xs whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
              >
                {copyText}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}